import type { CaseGetFilterDto, CaseResponseDto } from '@bandido/shared/dtos';

export function bookingCaseSearchFilters(
  agencyId: string | number | (string | number)[],
  search: string,
): CaseGetFilterDto {
  const agencies = Array.isArray(agencyId) ? agencyId : [agencyId];
  const numberMatch = search.trim().match(/^#?0*([1-9]\d*)$/);
  const caseId = numberMatch ? Number(numberMatch[1]) : undefined;
  const exactId = caseId && Number.isSafeInteger(caseId) && caseId <= 2_147_483_647 ? caseId : undefined;
  return {
    currentPage: 1,
    pageSize: 20,
    search: exactId ? '' : search,
    ...(exactId ? { caseIds: [exactId] } : {}),
    agencies: agencies.length ? agencies.map(String) : ['0'],
    hasClient: true,
  };
}

/** Defensa de UI: el backend filtra antes de paginar y este borde no mezcla agencias. */
export function eligibleBookingCaseOptions(
  cases: CaseResponseDto[],
  agencyId: string | number,
): CaseResponseDto[] {
  const expectedAgencyId = Number(agencyId);
  return cases.filter(
    (item) => item.agencyId === expectedAgencyId && Boolean(item.clientId),
  );
}
